<div class="min-h-screen flex items-center justify-center bg-[hsl(210_20%_98%)] px-4 py-10">
  <div class="w-full max-w-sm space-y-6 text-center">
    <a routerLink="/" class="inline-block">
      <img src="/images/attestio-logo.png" alt="Attestio" class="h-10 mx-auto mb-6" />
    </a>

    @if (status() === 'loading') {
      <div class="space-y-4">
        <span class="material-symbols-outlined text-secondary text-5xl animate-spin">progress_activity</span>
        <p class="text-[hsl(213_15%_46%)]">{{ message() }}</p>
      </div>
    } @else if (status() === 'success') {
      <div class="space-y-4">
        <div class="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto">
          <span class="material-symbols-outlined text-green-600 text-3xl">check_circle</span>
        </div>
        <h1 class="font-display text-2xl font-bold text-[hsl(213_55%_15%)]">E-mail vérifié</h1>
        <p class="text-[hsl(213_15%_46%)]">{{ message() }}</p>
        <a
          routerLink="/login"
          class="inline-block w-full h-11 leading-[2.75rem] rounded-lg bg-secondary text-white font-semibold hover:bg-secondary-hover transition-colors"
        >
          Se connecter
        </a>
      </div>
    } @else {
      <div class="space-y-4">
        <div class="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto">
          <span class="material-symbols-outlined text-red-600 text-3xl">error</span>
        </div>
        <h1 class="font-display text-2xl font-bold text-[hsl(213_55%_15%)]">Échec de la vérification</h1>
        <p class="text-[hsl(213_15%_46%)]">{{ message() }}</p>
        <a
          routerLink="/login"
          class="inline-block w-full h-11 leading-[2.75rem] rounded-lg bg-secondary text-white font-semibold hover:bg-secondary-hover transition-colors"
        >
          Retour à la connexion
        </a>
      </div>
    }
  </div>
</div>
